// {%- comment -%}
//   ============================================================================
//   === CLP PRICE & BADGE SYNC ENGINE ==========================================
//   ============================================================================
//   Zentrale Funktion updateClpItemPrice(index, variantId):
//     1. Liest die Variantendaten (inkl. Recharge-Selling-Plan-Allocations) aus
//        dem im Snippet eingebetteten JSON-Block.
//     2. Bestimmt anhand des aktiven Selling-Plans den korrekten finalen Preis:
//          - kein Plan / Einmalkauf  -> variant.price
//          - aktiver Plan            -> selling_plan_allocations[planId].price
//     3. Wendet ggf. den Custom-Discount (vom Block) on-top auf compare_at_price
//        an, falls aktiv.
//     4. Rendert den Preis-Block (Streichpreis durchgestrichen + finaler Preis).
//     5. Berechnet die Badge-Bubble DYNAMISCH aus genau diesen beiden Werten:
//           pct = round((compare - final) / compare * 100)
//        So passt der Badge immer zum tatsächlich angezeigten Preis.

//   Eingebunden:
//     - varchange()                         -> bei Variantenwechsel
//     - Subscription-Select 'change'-Event  -> bei Plan-/Einmalkauf-Wechsel
//     - DOMContentLoaded                    -> initialer Sync je Karte
//   ============================================================================
// {%- endcomment -%}



(function () {
  'use strict';

  // =========================
  // Helpers
  // =========================


  function getShopifyCurrencyRate() {
    if (window.Shopify && window.Shopify.currency && window.Shopify.currency.rate) {
      var r = parseFloat(window.Shopify.currency.rate);
      return isNaN(r) ? 1 : r;
    }
    return 1;
  }

  function getShopifyCurrencyIso() {
    if (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) {
      return window.Shopify.currency.active;
    }
    return (window.Shopify && window.Shopify.currency && window.Shopify.currency.base) || 'EUR';
  }

  function formatMoney(cents) {
    if (cents == null || isNaN(cents)) return '';
    var rate = getShopifyCurrencyRate();
    var iso = getShopifyCurrencyIso();
    var convertedCents = Math.round(cents * rate);
    var value = convertedCents / 100;

    try {
      return new Intl.NumberFormat(undefined, {
        style: 'currency',
        currency: iso,
      }).format(value);
    } catch (e) {
      return value.toFixed(2) + ' ' + iso;
    }
  }
  function parseVariantData(index) {
    var el = document.getElementById('clp-variant-data-' + index);
    if (!el) return null;
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      console.warn('[CLP] Konnte Variantendaten nicht parsen für index ' + index, e);
      return null;
    }
  }

  function getActivePlanId(index) {
    var select = document.getElementById('selling_plan_select_' + index);
    if (!select || select.selectedIndex < 0) return null;
    var opt = select.options[select.selectedIndex];
    if (!opt) return null;
    var planId = opt.dataset.sellingPlan;
    return planId && planId.length > 0 ? planId : null;
  }
  function getCurrentVariantId(index) {
    var nameInput = document.getElementById('name_' + index);
    return nameInput ? nameInput.value : null;
  }

  // =========================
  // Active section & nav highlight
  // =========================

  function initSectionHighlight() {
    const sections = document.querySelectorAll('.clp-collection-section');
    const navItems = document.querySelectorAll('.clp_discount_category_nav_li');
    if (!sections.length || !navItems.length) return;

    function updateActiveSection() {
      let current = '';

      sections.forEach(function (section) {
        const top = section.offsetTop - 120;
        if (window.scrollY >= top) {
          current = section.id.replace('collection-', '');
        }
      });

      navItems.forEach(function (item) {
        item.classList.remove('active_rabatt');
        if (item.dataset.handle === current) {
          item.classList.add('active_rabatt');
        }
      });
    }

    window.addEventListener('scroll', updateActiveSection, { passive: true });
    updateActiveSection();
  }

  // =========================
  // Scroll to top button
  // =========================

  function initScrollToTop() {
    const scrollBtn = document.getElementById('scrollToTop');
    if (!scrollBtn) return;

    function toggleScrollBtn() {
      if (window.scrollY > 300) {
        scrollBtn.classList.add('show');
      } else {
        scrollBtn.classList.remove('show');
      }
    }

    window.addEventListener('scroll', toggleScrollBtn, { passive: true });

    scrollBtn.addEventListener('click', function () {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });

    toggleScrollBtn();
  }

  // =========================
  // Horizontal slider drag
  // =========================

  function initSliderDrag() {
    const slider = document.querySelector('.clp_discount_category_nav');
    if (!slider) return;

    let isDown = false;
    let startX = 0;
    let scrollLeft = 0;

    slider.addEventListener('mousedown', function (e) {
      isDown = true;
      slider.classList.add('active');
      slider.style.scrollBehavior = 'auto';
      startX = e.pageX - slider.offsetLeft;
      scrollLeft = slider.scrollLeft;
    });

    window.addEventListener('mouseup', function () {
      isDown = false;
      slider.classList.remove('active');
      slider.style.scrollBehavior = '';
    });

    window.addEventListener('mousemove', function (e) {
      if (!isDown) return;
      e.preventDefault();
      const x = e.pageX - slider.offsetLeft;
      const walk = (x - startX) * 1.5; // speed factor
      slider.scrollLeft = scrollLeft - walk;
    });
  }

  // =========================
  // Price & badge sync engine
  // =========================

  function updateClpItemPrice(index, variantId) {
    var itemcard = document.getElementById('itemcard_' + index);
    if (!itemcard) return;

    var allVariants = parseVariantData(index);
    if (!allVariants) return;

    if (!variantId) variantId = getCurrentVariantId(index);
    if (!variantId) return;

    var variantData = allVariants[variantId];
    if (!variantData) return;

    var activePlanId = getActivePlanId(index);

    var finalPrice = variantData.price;
    var compareAt = variantData.compare;

    // === Recharge / Selling Plan Pricing ===
    if (activePlanId && variantData.plans && variantData.plans[activePlanId]) {
      var allocation = variantData.plans[activePlanId];
      finalPrice = allocation.price;

      if (variantData.compare && variantData.compare > 0) {
        compareAt = variantData.compare;
      } else if (allocation.compare && allocation.compare > 0) {
        compareAt = allocation.compare;
      } else {
        compareAt = variantData.price;
      }
    }

    // === Custom Discount Override (vom Block) ===
    var hasCustomDiscount = itemcard.getAttribute('data-has-custom-discount') === 'true';
    var customDiscountPct = parseFloat(itemcard.getAttribute('data-discount-percentage'));

    if (hasCustomDiscount && !isNaN(customDiscountPct) && customDiscountPct > 0) {
      var baseForCustom = variantData.compare && variantData.compare > 0 ? variantData.compare : variantData.price;
      compareAt = baseForCustom;
      finalPrice = Math.round(baseForCustom * (1 - customDiscountPct / 100));
    }

    // === Preis-Block rendern ===
    var priceWrapper = itemcard.querySelector('.clp_product_price_span');
    if (priceWrapper) {
      var hasCompare = compareAt && compareAt > finalPrice;
      priceWrapper.innerHTML =
        '<div class="remove-line-height-space clp_product_price">' +
        '<span class="product-price--original" style="margin-right: 8px; font-size: 18px;">' +
        formatMoney(finalPrice) +
        '</span>' +
        (hasCompare
          ? '<del class="product-price--compare" style="text-decoration: line-through; opacity: 0.6; font-size: 14px;"><span>' +
            formatMoney(compareAt) +
            '</span></del>'
          : '') +
        '</div>';
    }

    // === Badge dynamisch aus den real angezeigten Preisen ===
    var badge = itemcard.querySelector('.product-item__Badge.clp-dynamic-badge') ||
                itemcard.querySelector('.product-item__badge.clp-dynamic-badge');
    if (badge) {
      if (compareAt && compareAt > finalPrice) {
        var pct = Math.round(((compareAt - finalPrice) / compareAt) * 100);
        if (pct > 0) {
          badge.textContent = '-' + pct + '%';
          badge.style.display = '';
        } else {
          badge.style.display = 'none';
        }
      } else {
        badge.style.display = 'none';
      }
    }
  }
  // Expose globally for varchange / quick popup
  window.updateClpItemPrice = updateClpItemPrice;

  function attachPlanListeners() {
    document.querySelectorAll('.subscription-frequency select').forEach(function (select) {
      if (select.dataset.clpListenerAttached === 'true') return;
      select.dataset.clpListenerAttached = 'true';

      select.addEventListener('change', function () {
        var idx =
          select.dataset.clpIndex ||
          (function () {
            var m = select.id && select.id.match(/^selling_plan_select_(\d+)$/);
            return m ? m[1] : null;
          })();
        if (idx) updateClpItemPrice(idx);
      });
    });
  }

 function waitForShopifyCurrency(callback, attempts) {
    attempts = attempts || 0;
    var ready = window.Shopify && window.Shopify.currency && window.Shopify.currency.active;
    if (ready || attempts >= 30) {
      callback();
    } else {
      setTimeout(function () {
        waitForShopifyCurrency(callback, attempts + 1);
      }, 100);
    }
  }

function initialPriceSync() {
    attachPlanListeners();
    waitForShopifyCurrency(function () {
      document.querySelectorAll('[id^="itemcard_"]').forEach(function (item) {
        var m = item.id.match(/^itemcard_(\d+)$/);
        if (!m) return;
        updateClpItemPrice(m[1]);
      });
    });
  }

  // =========================
  // Subscription form handling (block-level)
  // =========================

  function initSubscriptionSelects() {
    document.querySelectorAll('.subscription-frequency select').forEach(function (select) {
      var form = select.closest('form');
      if (!form) return;

      var itemcard = select.closest('.product_item_inner');
      var showOnetime = itemcard ? itemcard.getAttribute('data-show-onetime') === 'true' : false;

      if (showOnetime && select.options.length > 1) {
        select.selectedIndex = 1;
      }

      var selected = select.options[select.selectedIndex];
      var planId = selected && selected.dataset.sellingPlan;
      if (planId) {
        var hidden = document.createElement('input');
        hidden.type = 'hidden';
        hidden.name = 'selling_plan';
        hidden.value = planId;
        form.appendChild(hidden);
      }

      select.addEventListener('change', function (e) {
        var existing = form.querySelector('input[name="selling_plan"]');
        if (existing) existing.remove();

        var selectedNew = e.target.options[e.target.selectedIndex];
        var planIdNew = selectedNew && selectedNew.dataset.sellingPlan;
        if (planIdNew) {
          var hiddenNew = document.createElement('input');
          hiddenNew.type = 'hidden';
          hiddenNew.name = 'selling_plan';
          hiddenNew.value = planIdNew;
          form.appendChild(hiddenNew);
        }

        if (window.updateClpItemPrice && itemcard) {
          var idMatch = itemcard.id.match(/^itemcard_(\d+)$/);
          if (idMatch) window.updateClpItemPrice(idMatch[1]);
        }
      });
    });
  }

  // =========================
  // Variant UI helpers (jQuery-based in your theme)
  // =========================

  window.discvars = function (para) {
    $('#var_' + para).slideToggle();
  };

  window.varchange = function (id, title, weight, unit, i, price, compareprice) {
    $('#name_' + i).val(id);

    var target = document.getElementById('selected_var_' + i);
    if (!target) {
      console.warn('Element #selected_var_' + i + ' not found');
      return;
    }

    var text = title.split(' ')[0];
    text += ' <span>' + weight + '</span>';
    target.innerHTML = text;

    if (window.updateClpItemPrice) {
      window.updateClpItemPrice(i, id);
    } else {
      // Fallback legacy logic
      var itemcard = document.getElementById('itemcard_' + i);
      if (itemcard) {
        var hasCustomDiscount = itemcard.getAttribute('data-has-custom-discount') === 'true';
        var discountPercentage = parseFloat(itemcard.getAttribute('data-discount-percentage'));
        if (hasCustomDiscount && discountPercentage && compareprice) {
          var variantComparePriceCents = parseFloat(compareprice.replace('€', '').replace(',', '.').trim()) * 100;
          var discountedPriceCents = Math.round(variantComparePriceCents * (1 - discountPercentage / 100));
          var formattedOriginal = (variantComparePriceCents / 100).toFixed(2).replace('.', ',') + ' €';
          var formattedDiscounted = (discountedPriceCents / 100).toFixed(2).replace('.', ',') + ' €';
          var priceWrapper = itemcard.querySelector('.clp_product_price_span');
          if (priceWrapper) {
            priceWrapper.innerHTML =
              '<del class="product-price--compare" style="text-decoration: line-through; opacity: 0.6; margin-right: 8px;"><span>' +
              formattedOriginal +
              '</span></del>' +
              '<span class="product-price--original">' +
              formattedDiscounted +
              '</span>';
          }
        }
      }
    }

    $('#var_' + i).slideToggle();
  };

  window.disc_submit = function (para) {
    $('#disc_submit_' + para).addClass('submitt');
    setTimeout(function () {
      $('#disc_submit_' + para).removeClass('submitt');
    }, 2000);
  };

  // =========================
  // Quick popup functions
  // =========================

  window.clp_quick = function (para) {
    $('#clp_quick_show_' + para).addClass('clp_quick_visible');
  };

  window.clp_close = function () {
    $('.clp_quick_popup').removeClass('clp_quick_visible');
  };

  window.select_var = function (iid, paraid) {
    var quickPopup = $('#clp_quick_show_' + iid);
    var itemcard = document.getElementById('itemcard_' + iid);

    var variantSpan = $('#var-' + paraid).find('span');
    var variantId = variantSpan.attr('vid');

    if (variantId) $('#name_' + iid).val(variantId);

    if (window.updateClpItemPrice && variantId) {
      window.updateClpItemPrice(iid, variantId);

      var priceWrapper = itemcard && itemcard.querySelector('.clp_product_price_span');
      if (priceWrapper) {
        quickPopup.find('.clp_product_price_span').html(priceWrapper.innerHTML);
      }
    } else {
      // Fallback legacy
      var hasCustomDiscount = itemcard && itemcard.getAttribute('data-has-custom-discount') === 'true';
      var discountPercentage = itemcard ? parseFloat(itemcard.getAttribute('data-discount-percentage')) : 0;
      var comparePriceText = variantSpan.attr('data-compare');

      if (hasCustomDiscount && discountPercentage && comparePriceText) {
        var variantComparePriceCents = parseFloat(comparePriceText.replace('€', '').replace(',', '.').trim()) * 100;
        var discountedPriceCents = Math.round(variantComparePriceCents * (1 - discountPercentage / 100));
        var formattedOriginal = (variantComparePriceCents / 100).toFixed(2).replace('.', ',') + ' €';
        var formattedDiscounted = (discountedPriceCents / 100).toFixed(2).replace('.', ',') + ' €';

        quickPopup
          .find('.clp_product_price_span')
          .html(
            '<del class="product-price--compare" style="text-decoration: line-through; opacity: 0.6; margin-right: 8px;"><span>' +
              formattedOriginal +
              '</span></del>' +
              '<span class="product-price--original">' +
              formattedDiscounted +
              '</span>'
          );
      } else {
        var priceText = variantSpan.attr('data-price');
        quickPopup.find('.clp_product_price_span').find('.product-price--original').text(priceText);
        quickPopup.find('.clp_product_price_span').find('.product-price--compare').text(comparePriceText);
      }
    }

    quickPopup.find('.product-variant__item').removeClass('selected');
    quickPopup.find('#var-' + paraid).addClass('selected');
    quickPopup.find('#var-' + paraid).click();

    return false;
  };

  window.popup_atc = function (para) {
    var quickPopup = $('#clp_quick_show_' + para);

    var selectedVariantInput;
    if (quickPopup.find('.product-variant__item.selected span').attr('vid')) {
      selectedVariantInput = quickPopup.find('.product-variant__item.selected span').attr('vid');
    } else {
      selectedVariantInput = quickPopup.attr('vid');
    }

    var selectedSellingPlanId = quickPopup.find('.delivery_interval_active.sellingplan').attr('data-selling-plan-id');

    var payload = {
      id: selectedVariantInput,
      quantity: 1,
      selling_plan: selectedSellingPlanId,
    };

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify(payload),
    })
      .then(function (response) {
        return response.json();
      })
      .then(function (data) {
        console.log('Added to cart:', data);
      })
      .catch(function (error) {
        console.error('Error adding to cart:', error);
      });

    $('.clp_quick_popup').removeClass('clp_quick_visible');
  };

  window.select_sellplan = function (para) {
    $('.sellingplan').removeClass('delivery_interval_active');
    $('.sellingplan[data-selling-plan-id="' + para + '"]').addClass('delivery_interval_active');
  };

  // =========================
  // Discount code & navigation
  // =========================

  window.clp_copy = function (discountcode) {
    navigator.clipboard.writeText(discountcode);
    $('.clp_discount_code span').text('Kopiert');
  };

  window.scrollToCollection = function (handle) {
    var section = document.getElementById('collection-' + handle);
    if (!section) return;
    section.scrollIntoView({
      behavior: 'smooth',
      block: 'start',
    });
  };

  // =========================
  // Default active tab
  // =========================

  function initDefaultTab() {
    var hasDefaultSelected = document.querySelector('.clp_discount_category_nav_li.active_rabatt');
    if (!hasDefaultSelected) {
      var firstTab = document.querySelector('.clp_discount_category_nav_li');
      if (firstTab) {
        firstTab.classList.add('active_rabatt');
      }
    }
  }

  // =========================
  // Badge prefix CSS var
  // =========================

  function initBadgePrefixes() {
    document.querySelectorAll('.clp_discount_category_nav_li a span[data-prefix]').forEach(function (el) {
      el.style.setProperty('--badge-prefix', '"' + el.getAttribute('data-prefix') + '"');
    });
  }

  // =========================
  // Initialization
  // =========================

  function initAll() {
    initSectionHighlight();
    initScrollToTop();
    initSliderDrag();
    initialPriceSync();
    initSubscriptionSelects();
    initDefaultTab();
    initBadgePrefixes();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();